import React, { useEffect, useState } from 'react';
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import ReactECharts from "echarts-for-react";

const NetatmoChart = () => {

    const [status, setStatus] = useState('NA');
    
    useEffect(() => {
        const controller = new AbortController();
        getNetatmoHistory();

        return () => {
            controller.abort();
        };
    }, []);

    const getNetatmoHistory = async () => {
        try {
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("idToken"),
                },
            };
            const history = await api.get("/netatmo/temp-history", config);
            setStatus(history.data);
        } catch {
            toast.error("API error getting temperatures history, please refresh the page");
        }
    };

    const getNetatmoOption = () => {
        if (status === 'NA') {
            return;
        }

        let tempData = [];
        let setpointData = [];
        let tsData = [];

        for (let i = status.samples["sample_nr"] - 1; i >= 0; i--) {
            let element = status.samples[i];
            tempData.push(element["temperature"]);
            setpointData.push(element["setpoint"]);
            tsData.push(element["server_timestamp"]);
        }


        var option = {
            tooltip: {
                trigger: "axis",
            },
            legend: {},
            toolbox: {
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    dataZoom: {},
                    dataView: { readOnly: false },
                    magicType: { type: ["line", "bar"] },
                    restore: {},
                    saveAsImage: {},
                },
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: tsData,
                axisLabel: {
                    showMinLabel: false
                }
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    formatter: "{value} °C",
                },
            },
            series: [
                {
                    name: "Temperature",
                    type: "line",
                    data: tempData,
                    markPoint: {
                        data: [
                            { type: "max", name: "Max" },
                            { type: "min", name: "Min" },
                        ],
                    },
                },
                {
                    name: "Setpoint",
                    type: "line",
                    data: setpointData,
                    markPoint: {
                        data: [
                            { type: "max", name: "Max" },
                            { type: "min", name: "Min" },
                        ],
                    },
                }
            ],
        };

        return option;
    };

    const renderChart = () => {
        if (status === 'NA') {
            return;
        }

        return (
            <ReactECharts
                option={getNetatmoOption()}
                notMerge={true}
                lazyUpdate={true}
            />
        );
    };

    return (
        <div className="device-chart" id="temperature-chart">
            {renderChart()}
        </div>
    );
}

export default NetatmoChart;
